import ApiHelper from './index';

const fetchAlertConfigs = (orgName, spinner = true) =>
  ApiHelper.get('device/alert-config/', spinner, { org: orgName });

const createAlertConfig = (payload, spinner = true) =>
  ApiHelper.post('device/alert-config/', payload, spinner);

const updateAlertConfig = (id, payload, spinner = true) =>
  ApiHelper.patch(`device/alert-config/${id}/`, payload, spinner);

const deleteAlertConfig = (id, spinner = true) =>
  ApiHelper.remove(`device/alert-config/${id}/`, spinner);

const addRecipient = (configId, email, spinner = true) =>
  ApiHelper.post(`device/alert-config/${configId}/recipients/`, { email }, spinner);

const deleteRecipient = (recipientId, spinner = true) =>
  ApiHelper.remove(`device/alert-config/recipients/${recipientId}/`, spinner);

export default {
  fetchAlertConfigs,
  createAlertConfig,
  updateAlertConfig,
  deleteAlertConfig,
  addRecipient,
  deleteRecipient,
};
